import LqdUITheme from './frontend/ui-theme/ui-theme';
import HeaderSimulatorModel from './frontend/header/simulator/model/simulator';
import HeaderSimulatorView from './frontend/header/simulator/view/simulator';

import lqdPageReload from './frontend/liquid-page-refresh';

import './frontend/hooks/global';
import './frontend/hooks/section';

(($) => {

  $(window).on( 'load', () => {

    _.defer(() => {
      
      const $body = $('body');
      const isHeaderPost = ElementorConfig.document.urls.permalink.search(/liquid-header/g) >= 0;
      const isFooterPost = ElementorConfig.document.urls.permalink.search(/liquid-footer/g) >= 0;
      
      if ( isHeaderPost ) {
        
        $body.addClass('single-liquid-header');
        
        const headerSimModel = new HeaderSimulatorModel();
        new HeaderSimulatorView({model: headerSimModel});
        
      };
      
      if ( isFooterPost ) {
        $body.addClass('single-liquid-footer');
      }
  
      new LqdUITheme();
  
      lqdPageReload($);

    })
    
  });

})(jQuery);